/**
 * @flow
 * @relayHash 10844e417b734cd6c9f09597790c6518
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LowStockListQueryVariables = {||};
export type LowStockListQueryResponse = {|
  +lowStockItems: $ReadOnlyArray<{|
    +item: {|
      +id: string,
      +itemNumber: string,
      +name: string,
    |},
    +onHand: number,
    +safetyQuantity: number,
    +shortfall: number,
  |}>
|};
export type LowStockListQuery = {|
  variables: LowStockListQueryVariables,
  response: LowStockListQueryResponse,
|};
*/


/*
query LowStockListQuery {
  lowStockItems {
    item {
      id
      itemNumber
      name
    }
    onHand
    safetyQuantity
    shortfall
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "lowStockItems",
    "storageKey": null,
    "args": null,
    "concreteType": "LowStockItem",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": null,
        "concreteType": "Item",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "itemNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "onHand",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "safetyQuantity",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shortfall",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LowStockListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LowStockListQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "LowStockListQuery",
    "id": null,
    "text": "query LowStockListQuery {\n  lowStockItems {\n    item {\n      id\n      itemNumber\n      name\n    }\n    onHand\n    safetyQuantity\n    shortfall\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8a130174aa6261587c9e32658a214d32';
module.exports = node;
